import { Box, BoxProps, Link, LinkProps, Stack, StackProps, styled } from '@mui/material'
import { ComponentType } from 'react'

export const HeaderContainer: ComponentType<StackProps> = styled( Stack )<StackProps>( ( { theme } ) => ( {
	maxWidth: theme.spacing( 100 ),
	marginTop: theme.spacing( 2, 0, 0, 0 ),
} ) )

export const BreadcrumbsLink: ComponentType<LinkProps> = styled( Link )( ( { theme } ) => ( {
	'textDecoration': 'none',
	'textAlign': 'center',
	'display': 'flex',
	'alignItems': 'center',
	'color': theme.palette.primary.main,
	'&:hover': {
		textDecoration: 'underline',
	},
} ) )

export const CenteredContainer: ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	minHeight: '60vh',
	gap: theme.spacing( 3 ),
} ) )

export const Section: ComponentType<StackProps> = styled( Stack )<StackProps>( ( { theme } ) => ( {
	marginBottom: theme.spacing( 2 ),
} ) )
